import Text from '$tablet-app/src/app/components/Text';
import { WeatherHourItem } from '$tablet-app/src/app/dashboard/WeatherDashboardWidget/WeatherHourItem';
import { OpenWeatherV2Response, weather_functions } from '@akin-home/weather';
import React from 'react';
import { Image, ScrollView, StyleSheet, View } from 'react-native';
import { WeatherIcons } from '../../../../../assets/weatherIcons';
import ChatWidget from '../ChatWidget';
import ChatWidgetHeader from '../ChatWidgetHeader';

interface Props {
  weather_data: OpenWeatherV2Response;
}

const WeatherChatView = ({ weather_data }: Props) => {
  return (
    <ChatWidget
      header={
        <ChatWidgetHeader icon={['fas', 'sun-cloud']} header_text="WEATHER" />
      }
      children={
        <View style={styles.body}>
          <View style={styles.weather_now}>
            <Image
              style={styles.large_icon}
              source={WeatherIcons[weather_functions.getIcon(weather_data)]}
            />
            <View style={styles.text_container}>
              {/* {location ? (
                <Text style={styles.location_text} variant="h3" weight="bold">
                  {location}
                </Text>
              ) : null} */}
              <Text style={styles.weather_text} variant="p" weight="regular">
                {weather_functions.getWeatherDescription(weather_data)}
              </Text>
              <View style={styles.temperature_container}>
                <Text
                  style={styles.temperature_text}
                  variant="h1"
                  weight="semibold"
                >
                  {weather_functions.getTemperatureText(weather_data)}
                </Text>
              </View>
            </View>
          </View>
          <ScrollView
            horizontal
            contentContainerStyle={styles.weatherDataContentContainer}
          >
            <View style={styles.weather_multiple}>
              {weather_data.hourly?.slice(1, 7).map((hour, i) => {
                return (
                  <View key={i} style={styles.weather_items_list}>
                    <WeatherHourItem
                      time={weather_functions.getHourTimeText(
                        weather_data,
                        hour
                      )}
                      icon={weather_functions.getHourIcon(hour)}
                      temperature={weather_functions.getHourTemperatureText(
                        hour
                      )}
                    />
                  </View>
                );
              })}
            </View>
          </ScrollView>
        </View>
      }
    />
  );
};
export default WeatherChatView;

const styles = StyleSheet.create({
  weatherDataContentContainer: {
    justifyContent: 'center',
    flexGrow: 1,
  },
  container: {
    padding: 10,
  },
  widget: {
    padding: 10,
    backgroundColor: 'rgba(5, 22, 51, 0.5)',
    borderRadius: 20,
    paddingBottom: 34,
    maxWidth: 500,
    maxHeight: '100%',
  },
  body: {
    flexShrink: 1,
    padding: 10,
  },
  weather_now: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },
  large_icon: {
    width: 70,
    height: 70,
  },
  small_icon: {
    width: 40,
    height: 40,
  },
  text_container: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 1,
    textAlign: 'right',
  },
  weather_text: {
    color: 'white',
  },
  temperature_text: {
    color: 'white',
  },
  weather_multiple: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    width: '100%',
    gap: 10,
  },
  weather_items: {
    flexDirection: 'row',
    paddingTop: 19,
    justifyContent: 'space-between',
    paddingLeft: 17,
    paddingRight: 31,
    alignItems: 'center',
  },
  weather_items_list: {
    paddingTop: 19,
    alignItems: 'center',
    flexDirection: 'column',
  },
  location_text: {
    color: 'white',
  },
  temperature_container: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    flex: 3,
  },
  small_time_text: {
    color: 'white',
  },
  small_temp_text: {
    color: 'white',
  },
  small_text: {
    color: 'white',
    textAlign: 'center',
  },
});
